/**
 * Using window properties (i.e window.document) and methods (i.e. window.addEventListener) is type-safe, but can blow up at runtime
 * if the code is executed on the server.
 *
 * This function is both a runtime guard (prevent exceptions), and a type guard (make typing easier).
 *
 * @example
 * // Do this
 * if (isClientSide(globalThis.window)) {
 *   global.window.addEventListener('click')
 * }
 *
 * // Do not do this (it will throw an exception during SSR)
 * isClientSide(window)
 */
export const isClientSide = (globalWindow: unknown): globalWindow is Window => {
  if (!globalWindow) return false;
  return typeof globalWindow !== 'undefined';
};
